import { CurrencyPipe, DatePipe, NgClass } from '@angular/common';
import { Component, inject, OnDestroy, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import {
  InfiniteScrollCustomEvent,
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonContent,
  IonHeader,
  IonIcon,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonItem,
  IonList,
  IonPopover,
  IonText,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';
import { BASE_CONFIG } from '@libs/core/base-config';
import { VxErrorComponent } from '@libs/core/lib/error-view/error-view.component';
import { NgEventBus } from '@libs/core/lib/event-bus/ng-event-bus';
import { VxCurrencyPipe } from '@libs/core/lib/pipes/mtjr-currency.pipe';
import { QuarterFloorPipe } from '@libs/core/lib/pipes/quarter-floor.pipe';
import { VxLoadingComponent } from '@libs/core/lib/shared/loading-state';
import { VxDynamicImageComponent } from '@libs/core/lib/shared/mtjr-image.component';
import { PaymentMethodSelectorComponent } from '@libs/mtjr/shared/shared/payment-method-selector.component';
import { WalletStore } from '@libs/mtjr/shared/wallet/wallet.store';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mtjr-wallet-page',
  standalone: true,
  imports: [
    PaymentMethodSelectorComponent,
    IonContent,
    IonToolbar,
    IonHeader,
    IonText,
    IonTitle,
    TranslatePipe,
    VxLoadingComponent,
    VxErrorComponent,
    IonItem,
    VxCurrencyPipe,
    DatePipe,
    NgClass,
    IonList,
    IonCard,
    IonButton,
    IonButtons,
    IonBackButton,
    IonIcon,
    CurrencyPipe,
    RouterLink,
    QuarterFloorPipe,
    VxDynamicImageComponent,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonPopover,
  ],
  templateUrl: './wallet.page.html',
})
export class WalletPageComponent implements OnDestroy {
  walletStore = inject(WalletStore);
  isPaymentModalOpen = signal(false);
  route = inject(ActivatedRoute);
  routeSub?: Subscription;
  modalCtrl = inject(ModalController);
  eventBus = inject(NgEventBus);
  eventsSub?: Subscription;
  flavor = inject(BASE_CONFIG).flavor;

  constructor() {
    this.walletStore.walletTransactionsListPage({});
    this.walletStore.refreshBalance();

    this.routeSub = this.route.queryParamMap.subscribe((params) => {
      if (params.get('action') === 'top-up') {
        this.isPaymentModalOpen.set(true);
      } else {
        this.isPaymentModalOpen.set(false);
      }
    });

    this.eventsSub = this.eventBus.on('wallet:fetch').subscribe(() => {
      this.isPaymentModalOpen.set(false);
    });
  }

  async onIonInfinite(event: InfiniteScrollCustomEvent) {
    await this.walletStore.walletTransactionsListFetchNextPage();
    await event?.target?.complete();
  }

  async ngOnDestroy() {
    this.routeSub?.unsubscribe();
    this.isPaymentModalOpen.set(false);
    this.eventsSub?.unsubscribe();
    await this.modalCtrl.dismiss();
  }
}
